import { useState } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import Fa from '../Fa';
import { Grid } from '../grid/Grid';

import './ToggleSection.css';

interface ToggleSectionProps {
  label: string | React.ReactNode;
  children: React.ReactNode;
  className?: string;
  actAsToggle?: boolean;
  headingLevel?: 'h2' | 'h3';
}

export default function ToggleSection({
  label,
  children,
  className,
  actAsToggle,
  headingLevel,
}: ToggleSectionProps): JSX.Element {
  const [opened, setOpened] = useState(false);
  const Heading = headingLevel || 'h3';

  function onToggle(): void {
    setOpened(!opened);
  }

  const idString = typeof label === 'string' ? _.kebabCase(label) : undefined;

  return (
    <article
      className={classNames(
        'toggle-section',
        actAsToggle ? 'toggle-section-toggled' : undefined,
        className,
        { opened },
      )}
    >
      <a tabIndex={0} className="toggle-section-button" id={idString} onClick={onToggle}>
        <Grid>
          <Heading className="toggle-section-title">{label}</Heading>
          <div className={classNames('toggle-section-arrow-container', { opened })}>
            <Fa
              icon="angle-down"
              className={classNames('toggle-section-arrow', { 'fa-rotate-180': opened })}
            />
          </div>
        </Grid>
      </a>
      <div className={classNames('toggle-section-content-wrapper', { opened })}>
        <Grid className="toggle-section-content">{children}</Grid>
      </div>
    </article>
  );
}

const defaultProps: Pick<ToggleSectionProps, 'className' | 'actAsToggle'> = {
  actAsToggle: true,
  className: undefined,
};

ToggleSection.defaultProps = defaultProps;
